import React from 'react'
import firebaseMenuMaker from '../firebase-menumaker'
import makeCloudinaryUrlForPhoto from '../utils/makeCloudinaryUrlForPhoto'
import './index.css'

const mapFirebaseChildren = (snapshot, func) => {
  let _ = []
  let index = 1
  snapshot.forEach((s) => {
    _.push(func(s, index))
    index++
  })
  return _
}

class Devices extends React.Component {
  state = {
    tvStateSnapshot: null
  }
  componentDidMount() {
    this.firebaseRef = firebaseMenuMaker.database()
      .ref(`tvStates/${this.props.shopId}`)
    this.firebaseRef.on('value', (snapshot) => {
      // snapshot docs: https://firebase.google.com/docs/reference/js/firebase.database.DataSnapshot
      console.log('snapshot.val()', snapshot.val())
      this.setState({ tvStateSnapshot: snapshot })
    })
  }
  componentWillUnmount () {
    this.firebaseRef.off()
  }

  render() {
    const {tvStateSnapshot} = this.state
    if (!tvStateSnapshot) {return null}
    return(
      <div>
        <h2 className="dashboard__section-title">
          Currently Published TVs
        </h2>
        <ul className="tv-state_list">
          {mapFirebaseChildren(tvStateSnapshot, (tvSnap) => {
            const handleDelete = () => {
                if (window.confirm('Are you sure you want to delete this TV?')) {
                firebaseMenuMaker.database().ref(`tvStates/${this.props.shopId}/${tvSnap.key}`).remove()
                }
            }
            return(
              <div key={tvSnap.key} className="tv-state__tv">
                <h3>tv# {tvSnap.key}  <button onClick={handleDelete}>Delete</button></h3>
                <div>{mapFirebaseChildren(tvSnap, (page) => {
                    const fullURL = page.child('url').val()
                    return(
                      <div key={page.key}>
                        <img src={makeCloudinaryUrlForPhoto(
                                  {pid: page.child('public_id').val(), type: 'cl'}, {cloud_name: 'afapuppet', width: 1000})}
                             alt=""/>

                        <input
                          value={fullURL}
                          
                        />
                      </div>
                    )
                  })}</div>
              </div>
            )
          })}
        </ul>
      </div>
    )
  }
}

export default Devices
